<template>
  <div>
    <span v-html="activityMessage"></span>
  </div>
</template>

<script>
export default {
  name: 'ContactModuleRulesRuleDeleted',
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    activityMessage() {
      const actor = this.activity?.actorUser?.name || 'Bilinmeyen Kullanıcı';
      const ruleName = this.activity?.payload?.ruleName || 'İsimsiz Kural';
      
      return this.$t('notification.contactModuleRulesRuleDeleted', {
        actor: `<strong>${actor}</strong>`,
        ruleName: `<strong>${ruleName}</strong>`
      });
    }
  }
};
</script>

<style scoped>
</style>

